import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Droplets, Sparkles, Wind, Filter, Brush, Sun, Trash2, MapPin } from 'lucide-react';

interface RelatedService {
  name: string;
  path: string;
  icon: 'pressure' | 'window' | 'carpet' | 'gutter' | 'soft' | 'solar' | 'dumpster';
}

interface ServiceCrossLinksProps {
  relatedServices: RelatedService[];
  currentService: string;
}

const iconMap = {
  pressure: <Droplets className="h-6 w-6 text-ventura-blue" />,
  window: <Sparkles className="h-6 w-6 text-ventura-blue" />,
  carpet: <Wind className="h-6 w-6 text-ventura-blue" />,
  gutter: <Filter className="h-6 w-6 text-ventura-blue" />,
  soft: <Brush className="h-6 w-6 text-ventura-blue" />,
  solar: <Sun className="h-6 w-6 text-ventura-blue" />,
  dumpster: <Trash2 className="h-6 w-6 text-ventura-blue" />,
};

const locations = [
  { name: 'Camarillo', path: '/camarillo' },
  { name: 'Fillmore', path: '/fillmore' },
  { name: 'Moorpark', path: '/moorpark' },
  { name: 'Oxnard', path: '/oxnard' },
  { name: 'Port Hueneme', path: '/port-hueneme' },
  { name: 'Santa Paula', path: '/santa-paula' },
  { name: 'Simi Valley', path: '/simi-valley' },
  { name: 'Thousand Oaks', path: '/thousand-oaks' },
  { name: 'Ventura', path: '/ventura' },
];

const ServiceCrossLinks: React.FC<ServiceCrossLinksProps> = ({ relatedServices, currentService }) => {
  return (
    <section className="section-padding bg-ventura-lightGray">
      <div className="container mx-auto">
        <div className="max-w-6xl mx-auto">
          {/* Related Services */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-center mb-8">Related Services</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {relatedServices.map((service) => (
                <Link key={service.path} to={service.path}>
                  <Card className="h-full hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                    <CardContent className="p-6 flex items-center gap-4">
                      {iconMap[service.icon]}
                      <span className="font-semibold text-gray-800 hover:text-ventura-blue transition-colors">
                        {service.name}
                      </span>
                    </CardContent>
                  </Card>
                </Link>
              ))}
            </div>
          </div>

          {/* Areas We Serve */}
          <div>
            <h2 className="text-2xl font-bold text-center mb-6">
              {currentService} Throughout Ventura County
            </h2>
            <p className="text-gray-600 text-center mb-6">
              We proudly offer our services to all communities in Ventura County:
            </p>
            <div className="flex flex-wrap justify-center gap-3">
              {locations.map((location) => (
                <Link
                  key={location.path}
                  to={location.path}
                  className="inline-flex items-center gap-1.5 px-4 py-2 bg-white rounded-full shadow-sm hover:shadow-md hover:bg-ventura-blue hover:text-white transition-all duration-300 text-gray-700"
                >
                  <MapPin className="h-4 w-4" />
                  {location.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceCrossLinks;
